(function () {
  "use strict";

  const CASCADE_CONFIG = JSON.parse(document.getElementById("cascade-filter-config").textContent);

  // HTML Entity Decoder to fix "&amp;" vs "&" issues
  function decodeHTMLEntities(text) {
    if (!text) return text;
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  const SVG = {
    chevronLeft:  `<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 5 7 9 3"/></svg>`,
    chevronRight: `<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 3 9 7 5 11"/></svg>`,
    backArrow:    `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="7.5 9 4.5 6 7.5 3"/></svg>`,
    placeholder:  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/><polyline points="21 15 16 10 5 21" stroke-width="2"/></svg>`,
  };

  const excludedFilters = CASCADE_CONFIG.excludedFilters
    .split(",").map((f) => f.trim().toLowerCase()).filter(Boolean);

  const filtersOrder = CASCADE_CONFIG.filtersOrder
    .split(",").map((f) => f.trim().toLowerCase()).filter(Boolean);

  function readMetaobjectData() {
    const data = {};
    CASCADE_CONFIG.filters.forEach(function (filter) {
      try {
        const el = document.getElementById('metaobject-data-' + filter.handle);
        if (el) { data[filter.label] = JSON.parse(el.textContent.trim()); } 
        else { data[filter.label] = {}; }
      } catch(e) { data[filter.label] = {}; }
    });
    return data;
  }

  const filterMetaobjects = readMetaobjectData();

  // Current product count + the values that still have products, per filter,
  // taken from the config block of the given document (page or fetched section).
  function readRuntimeFilterState(doc = document) {
    const el = doc.getElementById("cascade-filter-config");
    if (!el) return null;

    try {
      const parsed = JSON.parse(el.textContent.trim() || "{}");
      const filters = {};
      (parsed.filters || []).forEach((filter) => {
        filters[filter.param_name] = (filter.values || [])
          .filter((value) => value.count > 0)
          .map((value) => ({ value: value.value, count: value.count }));
      });
      return {
        productCount: Math.max(0, Number(parsed.productCount) || 0),
        filters
      };
    } catch (error) {
      console.warn("Cascade filter runtime data could not be parsed.", error);
      return null;
    }
  }

  let runtimeFilterState = readRuntimeFilterState();

  function getCurrentProductCount() {
    return runtimeFilterState
      ? Math.max(0, Number(runtimeFilterState.productCount) || 0)
      : 0;
  }

  function readCapacityIconData(doc = document) {
    const el = doc.getElementById('capacity-icon-data');
    return {
      image: el ? (el.dataset.image || '').trim() : '',
      iconSlug: el ? (el.dataset.iconSlug || '') : ''
    };
  }

  const capacityIconData = readCapacityIconData();
  let capacityIconImage = capacityIconData.image;
  let capacityIconSlug = capacityIconData.iconSlug;

  function readProductTypeImages(doc = document) {
    const el = doc.getElementById('product-type-images-data');
    if (el) {
      try { 
        const rawData = JSON.parse(el.textContent.trim() || '{}'); 
        const decodedData = {};
        for (const key in rawData) {
          decodedData[decodeHTMLEntities(key)] = rawData[key];
        }
        return decodedData;
      }
      catch(e) { return {}; }
    }
    return {};
  }
  let productTypeImages = readProductTypeImages();
  function readProductTypeOverrides(doc = document) {
  const el = doc.getElementById('product-type-override-data');
  if (!el) return {};
  try {
    const rawData = JSON.parse(el.textContent.trim() || '{}');
    const decodedData = {};
    for (const key in rawData) {
      decodedData[decodeHTMLEntities(key)] = rawData[key];
    }
    return decodedData;
  } catch (e) {
    return {};
  }
}
let productTypeOverrides = readProductTypeOverrides();

  const allFilters = CASCADE_CONFIG.filters.map(function (filter) {
    return {
      label: filter.label,
      type: filter.type,
      param_name: filter.param_name,
      values: filter.values.map((value) => ({ ...value, param_name: filter.param_name }))
    };
  })
    // entity decoder across all Liquid-generated strings
    .map(filter => ({
      ...filter,
      label: decodeHTMLEntities(filter.label),
      values: filter.values.map(v => ({
        ...v,
        label: decodeHTMLEntities(v.label),
        value: decodeHTMLEntities(v.value)
      }))
    }))
    .filter(({ label, type }) => {
      const ll = label.toLowerCase(), lt = type.toLowerCase();
      
       return !excludedFilters.some((ex) =>
        ll === ex || lt === ex
      );
    })
    .sort((a, b) => {
      const ai = filtersOrder.indexOf(a.label.trim().toLowerCase());
      const bi = filtersOrder.indexOf(b.label.trim().toLowerCase());
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return 0;
    });

  let swiperInstance = null;

  // Filters the user has explicitly skipped (param_name set). Skipping
  // is purely client-side state — it never touches the URL, since a
  // skipped filter has no selected value.
  let skippedFilters = new Set();

  // Step "pinning". When the shopper changes filters from the SIDEBAR the
  // cascade must stay on the level it is showing and only refresh that
  // level's values. It advances only for actions taken inside the cascade
  // (card click, Skip, Back, Reset).
  let displayedStepParam = null; // param_name of the step currently on screen
  let pinnedStepParam = null;    // param_name held in place after a sidebar change

  function hasAnyFilterInUrl() {
    for (const key of getParams().keys()) {
      if (key.startsWith("filter.")) return true;
    }
    return false;
  }

  function getStepFilter(filters, productCount) {
    if (pinnedStepParam) {
      const pinned = filters.find((f) => f.param_name === pinnedStepParam);
      // Stay on the pinned level while it still has something to show.
      if (pinned && pinned.values.length > 0) return pinned;
      pinnedStepParam = null;
    }
    return getNextFilter(filters, productCount);
  }


  let remainingProductTypes = [];
  let currentProductTypeFilter = null;

  const PRODUCT_TYPE_LIMIT = 24;
  const IMAGE_FETCH_LIMIT = 5; // max concurrent image-lookup fetches in flight at once

  function clearSkippedFiltersAfter(paramName) {
    const filterIndex = allFilters.findIndex(
      (filter) => filter.param_name === paramName
    );

    if (filterIndex === -1) return;

    allFilters
      .slice(filterIndex + 1)
      .forEach((filter) => {
        skippedFilters.delete(filter.param_name);
      });
  }



  function getContainer() {
    return document.getElementById("filterStepsContainer");
  }

  function getCollectionSectionId() {
    const section = document.getElementById("CollectionProductsParent");
    return section ? section.dataset.id : null;
  }

  

  function normalizeFilterValue(value) {
    return decodeHTMLEntities(String(value ?? "")).trim();
  }

  function getAvailableValues(filter) {
    const runtimeValues =
      runtimeFilterState?.filters?.[filter.param_name];

    if (Array.isArray(runtimeValues)) {
      const countByValue = new Map(
        runtimeValues.map((item) => [
          normalizeFilterValue(item.value),
          Math.max(0, Number(item.count) || 0)
        ])
      );

      const availableValues = filter.values
        .filter((value) =>
          countByValue.has(normalizeFilterValue(value.value))
        )
        .map((value) => ({
          ...value,
          count: countByValue.get(
            normalizeFilterValue(value.value)
          )
        }));

      console.log("FILTER CHECK:", filter.label, {
        originalValues: filter.values.map((value) => ({
          label: value.label,
          value: value.value
        })),
        runtimeValues,
        availableValues
      });

      return availableValues;
    }

    const checkboxes = document.querySelectorAll(
      `.collection-filter-sidebar input[type="checkbox"][name="${filter.param_name}"]`
    );

    const sidebar = document.querySelector(
      ".collection-filter-sidebar"
    );

    if (sidebar && !checkboxes.length) return [];
    if (!checkboxes.length) return filter.values;

    const presentValues = new Set(
      Array.from(checkboxes).map((checkbox) =>
        normalizeFilterValue(checkbox.value)
      )
    );

    return filter.values.filter((value) =>
      presentValues.has(normalizeFilterValue(value.value))
    );
  }  

  function getLiveFilters() { return allFilters.map((f) => ({ ...f, values: getAvailableValues(f) })); }
  function getParams() { return new URLSearchParams(window.location.search); }
  function isValueActive(paramName, value) { return getParams().getAll(paramName).includes(String(value)); }
  function isFilterActive(filter) { return filter.values.some((v) => isValueActive(v.param_name, v.value)); }

  

  function everyRemainingProductHasSameValues(filter, productCount) {
    if (productCount < 2 || productCount >= 5) return false;
    if (!filter.values.length) return false;

    // A filter can contain multiple values per product. When every available
    // value has a count equal to the remaining product count, every remaining
    // product has the same complete set of values, so the step adds no choice.
    return filter.values.every(
      (value) => Number(value.count) === productCount
    );
  }

  function getNextFilter(filters, productCount = getCurrentProductCount()) {
    return filters.find((filter) => {
      if (isFilterActive(filter)) return false;
      if (skippedFilters.has(filter.param_name)) return false;

      // Keep the existing single-value auto-skip behavior.
      if (filter.values.length <= 1) return false;

      // With 2-4 products left, skip a filter only when all remaining
      // products share the exact same complete set of filter values.
      if (everyRemainingProductHasSameValues(filter, productCount)) {
        return false;
      }

      return filter.values.some(
        (value) => !isValueActive(value.param_name, value.value)
      );
    }) || null;
  }

  function getLastActiveFilter() {
    const params = getParams();
    for (let i = allFilters.length - 1; i >= 0; i--) {
      const f = allFilters[i];
      // While a level is pinned, "Back" means the level before it, even if
      // the pinned level itself has a value picked in the sidebar.
      if (pinnedStepParam && f.param_name === pinnedStepParam) continue;
      const hasValue = params.has(f.param_name) && params.getAll(f.param_name).some(v => v !== "");
      if (hasValue || skippedFilters.has(f.param_name)) {
        return f;
      }
    }
    return null;
  }

  function buildFilterUrl(paramName, value) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set(paramName, value);
    params.delete("page");
    const qs = params.toString();
    return qs ? `${url.pathname}?${qs}` : url.pathname;
  }

  function buildBackUrl() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const lastActiveFilter = getLastActiveFilter();
    if (!lastActiveFilter) return url.pathname;

    params.delete(lastActiveFilter.param_name);
    params.delete("page");

    const qs = params.toString();
    return qs ? `${url.pathname}?${qs}` : url.pathname;
  }

  function buildResetUrl() {
    const params = getParams();
    const newParams = new URLSearchParams();
    if (params.get("sort_by")) newParams.set("sort_by", params.get("sort_by"));
    if (params.get("limit"))   newParams.set("limit",   params.get("limit"));
    const qs = newParams.toString();
    return qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  }

  // Re-read every piece of server-rendered cascade state from a fetched
  // section document. Must run after ANY filter change (cascade cards,
  // sidebar checkboxes, applied-filter chips, sort, browser back/forward),
  // otherwise the cascade keeps using the counts from the previous page state.
  function refreshStateFromDocument(doc) {
    if (!doc) return false;

    const newRuntimeFilterState = readRuntimeFilterState(doc);
    if (!newRuntimeFilterState) return false;
    runtimeFilterState = newRuntimeFilterState;

    productTypeImages = { ...productTypeImages, ...readProductTypeImages(doc) };
    productTypeOverrides = readProductTypeOverrides(doc);

    const newCapacity = readCapacityIconData(doc);
    if (doc.getElementById("capacity-icon-data")) {
      capacityIconImage = newCapacity.image;
      capacityIconSlug = newCapacity.iconSlug;
    }
    return true;
  }

  // Fallback for any code path that changes the URL/filters but does not hand
  // us the parsed response: fetch the section for the current URL ourselves.
  let stateRequestToken = 0;
  function refreshStateFromCurrentUrl() {
    const sectionId = getCollectionSectionId();
    if (!sectionId) { renderCurrentStep(); return; }

    const token = ++stateRequestToken;
    const url = new URL(window.location.href);
    url.searchParams.set("section_id", sectionId);

    fetch(url.pathname + url.search)
      .then((r) => r.text())
      .then((html) => {
        if (token !== stateRequestToken) return; // a newer update won
        refreshStateFromDocument(new DOMParser().parseFromString(html, "text/html"));
        renderCurrentStep();
      })
      .catch(() => {
        if (token === stateRequestToken) renderCurrentStep();
      });
  }

  function cascadeNavigate(targetUrl) {
    // Any navigation started inside the cascade is allowed to move levels.
    pinnedStepParam = null;
    const section = document.getElementById("CollectionProductsParent");
    if (!section) { window.location.href = targetUrl; return; }

    const sectionId     = section.dataset.id;
    const sectionParent = section.closest(".shopify-section");

    const fetchUrl = targetUrl + (targetUrl.includes("?") ? "&" : "?") + "section_id=" + sectionId;

    fetch(fetchUrl)
      .then(r => r.text())
      .then(responseText => {
        const resultData = new DOMParser().parseFromString(responseText, "text/html");

        refreshStateFromDocument(resultData);

        const newProducts = resultData.getElementById("CollectionProductsParent");
        const newSidebar  = resultData.querySelector(".collection-filter-sidebar");
        const curProducts = document.getElementById("CollectionProductsParent");
        const curSidebar  = document.querySelector(".collection-filter-sidebar");
        const mobileSort    = document.querySelector("[data-mobile-sort]");
        const newMobileSort = resultData.querySelector("[data-mobile-sort]");

        if (curProducts && newProducts) curProducts.innerHTML = newProducts.innerHTML;
        if (curSidebar  && newSidebar)  curSidebar.innerHTML  = newSidebar.innerHTML;
        if (mobileSort  && newMobileSort) mobileSort.innerHTML = newMobileSort.innerHTML;
        if (typeof syncTopbarClearAll === "function") syncTopbarClearAll(resultData);

        history.pushState({}, null, targetUrl);

        if (typeof applyFilters           === "function") applyFilters();
        if (typeof remove_filter          === "function") remove_filter(sectionParent, sectionId);
        if (typeof SidedrawerEventInit    === "function") SidedrawerEventInit();
        if (typeof collectionSwatch       === "function") collectionSwatch();
        if (typeof sortByoptions          === "function") sortByoptions();
        if (typeof loadMoreCollection     === "function") loadMoreCollection();
        if (typeof getCountDownElments    === "function") getCountDownElments();
        if (typeof quickviewElements      === "function") quickviewElements();
        if (typeof customDropdownElements === "function") customDropdownElements();
        if (typeof productCardHoverInit   === "function") productCardHoverInit();
        if (typeof bindMobileSortOutsideClick === "function") bindMobileSortOutsideClick();
        if (typeof AOS !== "undefined" && AOS) AOS.refreshHard();

        document.dispatchEvent(new CustomEvent("collectionFilterUpdated", {
          detail: { url: targetUrl, doc: resultData, source: "cascade" }
        }));
      })
      .catch(() => { window.location.href = targetUrl; });
  }

  function getFilterImage(filterLabel, value, label) {
    const meta = filterMetaobjects[filterLabel];
    if (meta) {
      const match = meta[String(value)] || meta[String(label)] || null;
      return match && match.image ? match.image : null;
    }
    return null;
  }

  const TEXT_ONLY_FILTERS = ["capacity", "size"];

  function buildSlideHTML(filter, value) {
    const isActive      = isValueActive(value.param_name, value.value);
    const labelLower    = filter.label.toLowerCase();
    const isCapacity    = labelLower === "capacity";
    const isProductType = labelLower === "product type";

    let isTextOnly = TEXT_ONLY_FILTERS.includes(labelLower);
    let imageUrl = null;
    let needsAjax = false;
    let ajaxUrl = "";

    // Capacity is normally text-only. When capacity_icons contains the
    // current collection and an image, use that image for every capacity
    // option while the capacity value remains visible as the card title.
        if (isProductType) {
      // 1) Metaobject override wins over everything.
      const overrideImage = productTypeOverrides[value.label] || null;
      if (overrideImage) {
        imageUrl = overrideImage;
        needsAjax = false;
      } else {
        // 2) Auto-fetched product image, or 3) AJAX lookup if none yet.
        imageUrl = productTypeImages[value.label] || null;
        if (!imageUrl) {
          needsAjax = true;
          const baseUrl = buildFilterUrl(value.param_name, value.value);
          const sectionId = getCollectionSectionId();
          ajaxUrl = sectionId
            ? baseUrl + (baseUrl.includes("?") ? "&" : "?") + "section_id=" + sectionId
            : baseUrl;
        }
      }
    } else if (isCapacity && capacityIconImage) {
      imageUrl = capacityIconImage;
      isTextOnly = false;
    } else if (!isTextOnly) {
      imageUrl = getFilterImage(filter.label, value.value, value.label);
    }

    if (!imageUrl) {
      isTextOnly = true;
    }

    let imageHTML;
    if (isTextOnly) {
      imageHTML = `<span class="filter-card-text-label">${value.label}</span>`;
    } else if (isCapacity) {
      imageHTML = `
        <span class="capacity-card-inner">
          <img src="${imageUrl}" alt="" loading="lazy">
          <span class="capacity-card-inside-label">${value.label}</span>
        </span>`;
    } else {
      imageHTML = `<img src="${imageUrl}" alt="${value.label}" loading="lazy">`;
    }

    const slideIconSlugClass = isCapacity && capacityIconSlug
      ? ` ${capacityIconSlug}`
      : '';

    return `
      <div class="swiper-slide${slideIconSlugClass}">
        <a class="filter-card${isActive ? " active" : ""}${isTextOnly ? " text-only" : ""}"
           href="#"
           data-param-name="${value.param_name}"
           data-value="${value.value}"
           data-needs-ajax="${needsAjax}"
           data-ajax-url="${ajaxUrl}"
           data-label="${value.label}"
        >
          <div class="filter-card-image">${imageHTML}</div>
          <div class="filter-card-title">${value.label}</div>
        </a>
      </div>`;
  }

  function buildViewAllSlideHTML(remainingCount) {
    return `
      <div class="swiper-slide">
        <a class="filter-card view-all-card" href="#" data-view-all="true">
          <div class="filter-card-image">
            <span class="view-all-count">+${remainingCount}</span>
          </div>
          <div class="filter-card-title">View All</div>
        </a>
      </div>`;
  }

  function renderCurrentStep() {
    const container = getContainer();
    if (!container) return;

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    const filters = getLiveFilters();
    const section = container.closest(".cascade-filter-section");
    const productCount = getCurrentProductCount();
    const lastActive = getLastActiveFilter();
    const backLinkHTML = lastActive
      ? `<a href="#" class="back-link" id="backToPrevious">${SVG.backArrow} Back to Choose ${lastActive.label}</a>`
      : "";

    // Once only one or zero products remain, there is no useful next choice.
    // Keep the cascade visible only when Back can still take the customer to
    // the previous decision.
    const nextFilter = productCount <= 1
      ? null
      : getStepFilter(filters, productCount);

    displayedStepParam = null;

    if (!nextFilter) {
      remainingProductTypes = [];
      currentProductTypeFilter = null;

      if (lastActive) {
        if (section) section.style.display = "";
        container.innerHTML = `
          <div class="filter-step filter-step--complete">
            <div class="filter-title-wrapper">
              ${backLinkHTML}
            </div>
          </div>`;
      } else {
        container.innerHTML = "";
        if (section) section.style.display = "none";
      }

      return;
    }

  if (productCount < 5) {
    remainingProductTypes = [];
    currentProductTypeFilter = null;

    if (lastActive) {
      if (section) section.style.display = "";

      container.innerHTML = `
        <div class="filter-step filter-step--back-only">
          <div class="filter-title-wrapper">
            ${backLinkHTML}
          </div>
        </div>
      `;
    } else {
      container.innerHTML = "";

      if (section) {
        section.style.display = "none";
      }
    }

    return;
  }

    if (section) section.style.display = "";
    displayedStepParam = nextFilter.param_name;

    const isProductType =
      nextFilter.label.toLowerCase() === "product type";

    let filterValues = nextFilter.values;
    let visibleValues = filterValues;

    if (isProductType && filterValues.length > PRODUCT_TYPE_LIMIT) {
      visibleValues = filterValues.slice(0, PRODUCT_TYPE_LIMIT);
      remainingProductTypes = filterValues.slice(PRODUCT_TYPE_LIMIT);
      currentProductTypeFilter = nextFilter;
    } else {
      visibleValues = filterValues;
      remainingProductTypes = [];
      currentProductTypeFilter = null;
    }

    const slidesHTML = visibleValues
      .map((value) => buildSlideHTML(nextFilter, value))
      .join("") + (
        remainingProductTypes.length
          ? buildViewAllSlideHTML(remainingProductTypes.length)
          : ""
      );

    container.innerHTML = `
      <div class="filter-step">
        <div class="filter-title-wrapper">
          ${backLinkHTML}
          <div class="filter-heading-row">
            <h3 class="filter-heading">Choose ${nextFilter.label}:</h3>
            <a href="#" class="skip-link" id="skipCurrentFilter">Skip</a>
          </div>
        </div>
        <div class="filter-cards-container">
          <div class="swiper filter-swiper">
            <div class="swiper-wrapper">${slidesHTML}</div>
          </div>
          <div class="swiper-scrollbar"></div>
        </div>
      </div>`;

    requestAnimationFrame(() => {
      const swiperEl = container.querySelector(".filter-swiper");
      if (!swiperEl || typeof Swiper === "undefined") return;

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: "auto",
        freeMode: true,
        grabCursor: true,
        scrollbar: {
          el: container.querySelector(".swiper-scrollbar"),
          draggable: true,
          hide: false,
          dragSize: "auto",
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          0: { spaceBetween: 10 },
          768: { spaceBetween: 15 },
        },
      });

      const missingImageCards = [
        ...container.querySelectorAll('.filter-card[data-needs-ajax="true"]')
      ];
      processProductTypeImages(missingImageCards);
    });
  }

  async function fetchProductTypeImage(card){

    const fetchUrl = card.dataset.ajaxUrl;
    const label = card.dataset.label;


    if(productTypeImages[label]){
      return;
    }


    try {


      const response = await fetch(fetchUrl);


      if(!response.ok){
        return;
      }


      const html = await response.text();


      const doc =
        new DOMParser()
        .parseFromString(html,"text/html");


      const img =
        doc.querySelector(
          'a[href*="/products/"] img'
        );


      if(!img){
        return;
      }


      const src =
        img.getAttribute('data-src') ||
        img.currentSrc ||
        img.src;



      if(src){


        card.querySelector('.filter-card-image')
        .innerHTML =
        `
        <img 
          src="${src}"
          alt="${label}"
          loading="lazy">
        `;


        card.classList.remove(
          "text-only"
        );


        productTypeImages[label]=src;

      }


    }
    catch(error){

      console.warn(
        "Product type image error:",
        label
      );

    }
    finally {

      card.dataset.needsAjax = "false";
    }


  }



  async function processProductTypeImages(cards){

    if (!cards.length) return;

    let nextIndex = 0;

    async function worker() {
      while (nextIndex < cards.length) {
        const card = cards[nextIndex++];
        await fetchProductTypeImage(card);
      }
    }

    const workerCount = Math.min(IMAGE_FETCH_LIMIT, cards.length);
    await Promise.all(Array.from({ length: workerCount }, worker));

  }


  document.addEventListener("click", (e) => {


    const viewAllCard =
    e.target.closest(
    '.view-all-card'
    );


    if(viewAllCard){


    e.preventDefault();


    const wrapper =
    document.querySelector(
    '.filter-swiper .swiper-wrapper'
    );

    const viewAllSlide = viewAllCard.closest(".swiper-slide");


    const html =
    remainingProductTypes
    .map(value =>
      buildSlideHTML(
        currentProductTypeFilter,
        value
      )
    )
    .join("");

    const temp = document.createElement("div");
    temp.innerHTML = html;
    const newSlideNodes = Array.from(temp.children);

    newSlideNodes.forEach((node) => wrapper.insertBefore(node, viewAllSlide));
    if (viewAllSlide) viewAllSlide.remove();


    remainingProductTypes=[];



    if(swiperInstance){

      swiperInstance.update();

    }


    const newCards = newSlideNodes.flatMap((node) =>
      Array.from(
        node.querySelectorAll('.filter-card[data-needs-ajax="true"]')
      )
    );


    processProductTypeImages(
      newCards
    );


    return;

    }   



    const card = e.target.closest(".filter-card");
    
    if (card) {
      e.preventDefault();

      const paramName = card.dataset.paramName;
      const value = card.dataset.value;

      skippedFilters.delete(paramName);

      clearSkippedFiltersAfter(paramName);

      cascadeNavigate(
        buildFilterUrl(paramName, value)
      );

      return;
    }
    const removeBtn = e.target.closest("[data-remove-url]");
    if (removeBtn) {
      e.preventDefault();
      cascadeNavigate(removeBtn.dataset.removeUrl);
      return;
    }
    if (e.target.closest("#skipCurrentFilter")) {
      e.preventDefault();
      const current = getStepFilter(getLiveFilters(), getCurrentProductCount());
      if (current) {
        pinnedStepParam = null;
        skippedFilters.add(current.param_name);

        renderCurrentStep();
      }
      return;
    }
    if (e.target.closest("#backToPrevious")) {
      e.preventDefault();
      const lastActive = getLastActiveFilter();
      if (lastActive && skippedFilters.has(lastActive.param_name)) {

        pinnedStepParam = null;
        skippedFilters.delete(lastActive.param_name);
        renderCurrentStep();
      } else {
        cascadeNavigate(buildBackUrl());
      }
      return;
    }
    if (e.target.closest("#resetAllFilters")) {
      e.preventDefault();
      skippedFilters.clear();
      cascadeNavigate(buildResetUrl());
    }
  });

  

  document.addEventListener(
    "collectionFilterUpdated",
    (event) => {
      const isHistoryNavigation = Boolean(
        event.detail &&
        event.detail.historyNavigation
      );

      if (isHistoryNavigation) {
        skippedFilters.clear();
      }

      const fromCascade = Boolean(
        event.detail && event.detail.source === "cascade"
      );

      if (fromCascade || isHistoryNavigation || !hasAnyFilterInUrl()) {

        pinnedStepParam = null;
      } else {

        pinnedStepParam = displayedStepParam || pinnedStepParam;
      }

      stateRequestToken++;

      const doc = event.detail && event.detail.doc;
      if (refreshStateFromDocument(doc)) {
        renderCurrentStep();
      } else {
        refreshStateFromCurrentUrl();
      }
    }
  );
  function init() {
    if (typeof Swiper === "undefined") { setTimeout(init, 100); return; }
    renderCurrentStep();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
